import instance from '../utils/axios';

class WechatService {
    async getOpenId(code, state) {
        return await instance.get("/crm/wechat/getOpenId?code=" + code + "&state=" + state);
    }

    async bind(enterprise, account, password, openId) {
        return await instance.post('/crm/wechat/bind', {
            enterpriseName: enterprise,
            txtUsername: account,
            txtPassword: password,
            openId
        });
    }
}

export default new WechatService();